import { ListItem } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledListItem = styled(ListItem) `
  justify-content: space-between;
`;
